// Set Focus to Scan-Field after Dom was loaded
document.addEventListener("DOMContentLoaded", function() {
  const scanField = document.getElementById('scanField');
  scanField.focus();
});
